export const formatDateForInput = (date: any): string => {
  if (!date) return "";

  if (typeof date === "object" && date.$date) {
    const d = new Date(date.$date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  }

  if (date instanceof Date) {
    return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
  }

  if (typeof date === "string") {
    const d = new Date(date);
    if (!isNaN(d.getTime())) {
      return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
    }
    return date;
  }

  return "";
};